import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Nov 07 2018
 * @author BPo
 */
import * as React from 'react';
import { FormContextConsumer } from '../Form/FormContext';
/**
 * These are the props that <Form/> provides to your render function or component.
 * Keep in mind that the values you receive here are dependent upon which values of
 * FormState you have subscribed to with the subscription prop.
 */

export var RenderPropsProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RenderPropsProvider, _React$PureComponent);

  function RenderPropsProvider() {
    _classCallCheck(this, RenderPropsProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(RenderPropsProvider).apply(this, arguments));
  }

  _createClass(RenderPropsProvider, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(FormContextConsumer, null, function (_ref) {
        var formRenderProps = _ref.formRenderProps;
        return _this.props.component(formRenderProps);
      });
    }
  }]);

  return RenderPropsProvider;
}(React.PureComponent);